<template>
  <!-- 试题选项--针对单选、多选-->
  <div>
    <!-- 选项 -->
    <ul class="option_arr" :class="isLook ? 'look_option' : ''">
      <li v-for="option in item.answerJsonDetailDtos" :key="option.orders">
        <i class="option" :class="option.isSelect ? 'options_look' : ''">{{ option.prefix }}</i>
        <div>
          <span v-if="option.contents"><span v-if="_decodeURIComponent(option.contents).indexOf('http') === -1"
            v-html="_decodeURIComponent(option.contents)"></span>
          <img v-else class="option_img" alt="试题选项" :src="_decodeURIComponent(option.contents)" /></span>
          <span v-else>未设置</span>
          ({{ option.score }}分)
        </div>
      </li>
    </ul>
    <!-- 答案 -->
    <ul class="ans_ul">
      <li class="line">
        学员作答：<span :class="item.studentAnswer
      ? 'green_font'
      : 'red_font'
      ">{{ item.studentAnswer ? item.studentAnswer : "未作答" }}</span>
      </li>
      <li class="line">
        学员得分：<span class="green_font">{{ item.score }}分</span>
      </li>
    </ul>
    <!-- 教师评分： -->
    <ul class="teacher_score">
      <!-- <li>
        教师评分：
        <el-input style="width: 30%" type="number" v-model="item.teacherScore"
          @input="inputFunc(item.orders, item.teacherScore)">
        </el-input>
        分
      </li> -->
      <!-- <li>
        教师评语：
        <el-input style="width: 86%" type="text" placeholder="请输入本题评语（可以留空）" v-model="item.comment" maxlength="100"
          show-word-limit>
        </el-input>
      </li> -->
    </ul>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "SelectsType",
  props: {
    // selectsArr: Array,
    item: Object,
    subjectType: Number,
    isLook: {
      type: Boolean,
      default: false,
    }
  },
  created() {
    this.item.title = this.item.title?.replace(
      /<img/g,
      "<img style='width:80px;height:auto;'"
    );
    // 选项数组
    if (this.item.answerJsonDetailDtos) {
      //单选题
      if (this.subjectType == 1) {
        //  判断选项数组中的isSelect是否有true
        let flag = false
        this.item.answerJsonDetailDtos.forEach((option) => {
          if (option.isSelect) {
            flag = true
            this.item.studentAnswer = option.prefix;
          }
        });
        if(!flag){
          this.item.studentAnswer = null;
        }
        // if (
        //   this.item.answerJsonDetailDtos.some(
        //     (e) => this.item.answerJsonDetailDtos.filter((e1) => e1.isSelect !== e.isSelect).length > 1
        //   )
        // ) {
        //   // 有作答
        //   this.item.answerJsonDetailDtos.forEach((option) => {
        //     if (option.isSelect) {
        //       this.item.studentAnswer = option.prefix;
        //     }
        //   });
        // } else {
        //   // 没有作答
        //   this.item.answerJsonDetailDtos.forEach((option) => {
        //     this.item.studentAnswer = null;
        //   });
        // }
      }
      // 多选题
      if (this.subjectType == 2) {
        this.item.correctAnswer = "";
        this.item.studentAnswer = "";
        //部分选
        if (
          this.item.answerJsonDetailDtos.some(
            (e) =>
              this.item.answerJsonDetailDtos.filter((e1) => e1.isSelect != e.isSelect).length >
              1
          )
        ) {
          this.item.answerJsonDetailDtos.forEach((option) => {
            if (option.isSelect) {
              this.item.studentAnswer += option.prefix + "";
            }
          });
        }
        // 全选
        if (
          this.item.answerJsonDetailDtos.every(
            (val, i, arr) =>
              val.isSelect === arr[0].isSelect && val.isSelect === true
          )
        ) {
          this.item.answerJsonDetailDtos.forEach((option) => {
            this.item.studentAnswer += option.prefix + "";
          });
        }
        //未选
        if (
          this.item.answerJsonDetailDtos.every(
            (val, i, arr) =>
              val.isSelect === arr[0].isSelect && val.isSelect === false
          )
        ) {
          this.item.answerJsonDetailDtos.forEach((option) => {
            this.item.studentAnswer = null;
          });
        }
      }
    }
    // });

  },
  watch: {
    selectsArr: {
      handler(newValue) {
        this.$emit("change-select", newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    _decodeURIComponent(str) {
      try {
        return decodeURIComponent(str)
      } catch (e) {
        return str
      }
    },
    inputFunc(index, val) {
      // 判断当前是哪个input输入框改变
      // this.selectsArr.map((item) => {
      if (this.item.orders == index) {
        if (val > this.item.score) {
          this.$alert(
            "亲:试题分数不能大于[试题满分]请重新评分！",
            "友情提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                this.item.teacherScore = 0;
              },
            }
          );
          return false;
        }
      }
      // });
    },
  },
};
</script>

<style scoped>
.look_option .options_look {
  width: 28px;
  height: 28px;
  background: #44b038;
  color: #fff;
  border: 1px solid #44b038;
}
</style>